const C = require("../constants");
const initial_data = {open: false, data:{name:null}};

function ModalIngredientStockReducer(state =initial_data, action) {
    switch (action.type) {
        case C.INGREDIENTS_STOCK_MODAL:
            return action.data;
        default:
            return state;
    }
}

export default ModalIngredientStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalIngredientStockReducer.js